import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const RoundedSquare = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<g id="roundedSquare" transform="translate(-25.000000, -185.000000)" fill={color}>
				<rect id="Rectangle-Copy-2" x="25" y="185" width="20" height="20" rx="3" />
			</g>
		</CustomSVGIcon>
	);
};

RoundedSquare.propTypes = {
	color: PropTypes.string,
};

export default RoundedSquare;
